import { ReactComponent as FilterSvg } from "assets/Svgs/FilterSvg.svg";
import { ReactComponent as CloseSvg } from "assets/Svgs/CloseSvg.svg";
import { ReactComponent as DownloadSvg } from "assets/Svgs/DownloadSvg.svg";
import { ReactComponent as HistorySvg } from "assets/Svgs/HistorySvg.svg";

import i18n from "i18n/i18n";

import {
  Box,
  Collapse,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  SelectChangeEvent,
} from "@mui/material";
import NotificationCardItem from "../../../components/NotificationCardItem";
import clsx from "clsx";
import { useEffect, useState } from "react";
import IconText from "components/IconText";
import { ReactComponent as TodaySvg } from "assets/Svgs/TodaySvg.svg";
import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  pdf,
} from "@react-pdf/renderer";
import moment from "moment";
import Paper from "@mui/material/Paper";
import { NotificationStatus, NotificationType } from "assets";
import { EmptyState } from "components/EmptyState";
import { GetNotificationBorderColor, getProgressStatus } from "shared-functions/notification";
import { saveAs } from "file-saver";
import { useBoundStore } from "store/store";
import _ from "lodash";
var adjust_year = "";

const icon = (
  <Paper sx={{ m: 1, width: 100, height: 100 }} elevation={4}>
    <svg>
      <Box
        component="polygon"
        points="0,100 50,00, 100,100"
        sx={{
          fill: (theme) => theme.palette.common.white,
          stroke: (theme) => theme.palette.divider,
          strokeWidth: 1,
        }}
      />
    </svg>
  </Paper>
);

function History(props: any) {
  const [notifications, setNotifications] = useState<Array<any>>([]);
  const [typeFilterEnabled, setIsTypeFilterEnabled] = useState<Boolean>(false);
  const [statusFilterEnabled, setIsStatusFilterEnabled] =
    useState<Boolean>(false);

  const { machineData } = props;
  const [keywordValue, setKeywordValue] = useState("");

  const filterByKeyword = (array: any) => {
    // Filter notifications based on the selected type
    return array.filter((notification: any) => {
      return notification.notification.title
        .toLowerCase()
        .includes(keywordValue.toLowerCase());
    });
  };

  useEffect(() => {
    setNotifications(machineData?.equipment?.hasnotification);
  }, [machineData]);

  const [showFilter, setShowFilter] = useState(false);

  const getCurrentYear = () => {
    let newDate = new Date();
    let year = newDate.getFullYear();

    return `${year}`;
  };

  const getYearFromTS = (timestamp: any) => {
    let d = new Date(timestamp);
    return d.getFullYear();
  };

  const [typeValue, setTypeValue] = useState("");
  const [statusValue, setStatusValue] = useState("");

  const handleChange = () => {
    setShowFilter((prev) => !prev);
  };

  const handleTypeChange = (event: SelectChangeEvent<string>) => {
    if (event.target.value === "alle") {
      setIsTypeFilterEnabled(false);
    } else {
      setIsTypeFilterEnabled(true);
    }
    setTypeValue(event.target.value);
  };
  const FilterNotificationsByType = (result: any) => {
    let filtered;
    if (typeValue !== "alle") {
      // Filter notifications based on the selected type
      filtered = result.filter((notification: any) => {
        return notification.notification.type === typeValue;
      });

      // Update the state with the filtered notifications
    } else {
      filtered = machineData?.equipment?.hasnotification;
    }
    return filtered;
  };

  const handleStatusChange = (event: SelectChangeEvent<string>) => {
    if (event.target.value === "alle") {
      setIsStatusFilterEnabled(false);
    } else {
      setIsStatusFilterEnabled(true);
    }
    setStatusValue(event.target.value);
    // FilterNotificationsByStatus(selectedValue);
  };
  const FilterNotificationsByStatus = (result: any) => {
    let filtered;
    if (statusValue !== "alle") {
      // Filter notifications based on the selected type
      const filteredNotifications = result.filter((notification: any) => {
        return notification.notification.status === +statusValue;
      });

      // Update the state with the filtered notifications
      filtered = filteredNotifications;
    } else {
      filtered = machineData?.equipment?.hasnotification;
    }
    return filtered;
  };

  useEffect(() => {
    let data = machineData?.equipment?.hasnotification;
    if (data?.length) {
      data = typeFilterEnabled ? FilterNotificationsByType(data) : data;
      data = statusFilterEnabled ? FilterNotificationsByStatus(data) : data;
      data = keywordValue.length > 0 ? filterByKeyword(data) : data;
      if (showFilter) {
        setNotifications(data);
      }
    }
  }, [typeValue, statusValue, keywordValue]);

  const pdf_styles = StyleSheet.create({
    dashedLine: {
      width: "100%",
      height: "1px",
      border: "1px solid black",
      borderStyle: "dashed",
      marginTop: "25px",
    },
    normalFont: {
      fontSize: "10px",
    },
    rowMain: {
      flexDirection: "row",
      flexGrow: 1,
      justifyContent: "space-between",
      fontSize: "10px",
      marginTop: 5,
      width: "100%",
    },
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    title: {
      fontSize: 14,
      marginBottom: 10,
      fontWeight: 900,
    },
    title2: {
      fontSize: 14,
      marginBottom: 10,
      fontWeight: "bold",
      textDecoration: "underline",
    },
    italic: {
      fontStyle: "italic",
    },
    author: {
      fontSize: 12,
      textAlign: "center",
      marginBottom: 40,
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
      fontFamily: "Oswald",
    },
    text: {
      margin: 12,
      fontSize: 14,
      textAlign: "justify",
      fontFamily: "Times-Roman",
    },
    image: {
      marginVertical: 15,
      marginHorizontal: 100,
    },
    header: {
      fontSize: 12,
      marginBottom: 20,
      textAlign: "center",
      color: "grey",
    },
    pageNumber: {
      position: "absolute",
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: "center",
      color: "grey",
    },
    logo: {
      width: "110px",
      height: "30px",
    },
    section45: {
      width: "45%",
    },
    section10: {
      width: "10%",
    },
    mainImages: {
      width: "45%",
      flexDirection: "row",
      flexGrow: 1,
    },
    notiImages: {
      width: " 100%",
      flexDirection: "row",
      flexGrow: 1,
      flexWrap: "wrap",
      display: "flex",
    },
    machineDesc: {},
    machineDesc_standort: {
      marginTop: 10,
      marginBottom: 20,
    },
    noti_status: {
      marginTop: 5,
      marginBottom: 10,
      fontSize: "10px",
    },

    noti_erstellt: {
      fontSize: "10px",
    },
    noti_desc: {
      marginTop: 15,
      marginBottom: 15,
      fontSize: "10px",
      textDecoration: "underline",
    },
    anhange: {
      fontSize: "10px",
      textDecoration: "underline",
      marginBottom: "10px",
    },
  });

  const user: any = useBoundStore((state) => state.user);

  const getAttachmentByType = (noti: any,type:any) => {
    let images: any = [];
    if (noti.notification.hasattachment) {
      noti.notification.hasattachment.filter((attach: any) => {
        if (attach.attachment.file.mimetype.includes(type)) {
          images.push(attach);
        }
      });
    }
    return images;
  };

  const MyDoc = () => (
    <Document>
      <Page style={pdf_styles.body}>
        <View>
          <View style={pdf_styles.rowMain}>
            <View>
              <Text style={{ marginTop: "2px" }}>
                Report am {moment(new Date()).format("DD.MM.YYYY")} , durch{" "}
                {(user?.givenname ? user?.givenname : "") +
                  " " +
                  (user?.surname ? user?.surname : "")}
              </Text>
            </View>
            <View></View>
          </View>

          <View style={{ margin: "20px 0px" }}></View>

          <View style={pdf_styles.rowMain}>
            <View style={pdf_styles.section45}>
              <Text style={pdf_styles.title}>
                {
                  machineData?.equipment?.hasequipmenttype[0]?.equipmenttype
                    ?.isequipmenttypeof[0]?.brand?.name
                }{" "}
                {
                  machineData?.equipment?.hasequipmenttype[0]?.equipmenttype
                    ?.model
                }{" "}
              </Text>

              <Text style={pdf_styles.machineDesc}>
                Inventar-Nr: {machineData?.equipment?.inventoryid}
              </Text>
              <Text style={pdf_styles.machineDesc}>
                Equipment-Nr: {machineData?.equipment?.equipmentid}
              </Text>
              <Text style={pdf_styles.machineDesc}>
                Geräteserien-Nr:{" "}
                {machineData?.equipment?.manufacturerserialnumber}
              </Text>
              <Text style={pdf_styles.machineDesc_standort}>
                Standort: {machineData?.equipment?.isequipmentof[0]?.area?.name}
              </Text>

              <Text style={pdf_styles.title2}>Export der Geräte-Historie</Text>
            </View>
            <View style={pdf_styles.section10}></View>
            <View style={pdf_styles.mainImages}>
              {machineData?.equipment?.typenameplate?.url ? (
                <Image
                  src={machineData?.equipment?.typenameplate?.url}
                  style={{ width: "100%", marginRight: "7px" }}
                />
              ) : (
                ""
              )}

              <Image
                src={machineData?.equipment?.image.url}
                style={{ width: "100%" }}
              />
            </View>
          </View>

          

          {notifications.map((noti: any, key: any) => {
        
            let pics = getAttachmentByType(noti,"image");
            let videos = getAttachmentByType(noti,"video");
            let docs = getAttachmentByType(noti,"application");

            return (
              <View key={key}>
                <View style={pdf_styles.dashedLine}></View>
                <Text style={{ fontSize: "10px", margin: "2% 0% 0% 0%" }}>
                  {NotificationType(Number(noti?.notification?.type), lang)}
                </Text>
                <Text style={{ fontSize: "10px", margin: "0% 0% 2% 0%" }}>
                  {noti.notification.title}
                </Text>

                <Text style={pdf_styles.noti_status}>
                  Status:{" "}
                  {NotificationStatus(Number(noti.notification.status), lang)} , {getProgressStatus(noti.notification,lang)}
                </Text>

                <Text style={pdf_styles.noti_erstellt}>
                  Erstellt Duruch :{" "}
                  {noti?.notification?.hasauthor
                    ? noti?.notification?.hasauthor[0]?.user?.givenname
                    : ""}{" "}
                  {noti?.notification?.hasauthor
                    ? noti?.notification?.hasauthor[0]?.user?.surname
                    : ""}
                </Text>

                <Text style={pdf_styles.noti_erstellt}>
                  Erstellt am{" "}
                  {moment(noti.notification.created).format("DD.MM.YYYY")}
                </Text>

                <Text style={pdf_styles.noti_desc}>
                  Beschreibung der Meldung
                </Text>
                <Text style={pdf_styles.normalFont}>
                  {noti.notification.description[lang]}
                </Text>

                <View style={{ fontSize: "10px", margin: "2% 0%" }}>
                  <Text style={pdf_styles.anhange}>Anhänge:</Text>
                  <Text style={{ marginBottom: "2%"}}>Photos : {pics.length}</Text>
                  {pics.length > 0 ? (
                    <View style={pdf_styles.notiImages}>
                      {pics.map((pic: any, index: number) => {
                        return (
                          <View style={{ width:"30%", marginRight: "4%", borderRadius:"4px"}}>
                            <Image
                              src={pic.attachment.file.url}
                              style={{ width: "100%",borderRadius:"4px" }}
                            />
                          </View>
                        );
                      })}
                    </View>
                  ) : (
                    ""
                  )}

                
                </View>

                <View style={{ fontSize: "10px", margin: "2% 0%" }}>
                  <Text>Videos : {videos.length}</Text>
                  <Text>Docs : {docs.length}</Text>
                </View>
              </View>
            );
          })}
        </View>

        <Text
          style={pdf_styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );

  const handleExportClick = async () => {
    const blob = await pdf(<MyDoc />).toBlob();
    saveAs(blob, "Equipment Report");
  };

  const lang: any = useBoundStore((state) => state.lang);

  return (
    <>
     

      <div className="historyWrapper">
        <div className="flex fBetween fCenter">
          <div className="generalHeading" style={{ padding: "0px" }}>
            {i18n(lang)?.deviceHistory}
          </div>
        
        </div>
        <div className="history_description">
          {i18n(lang)?.history_description}
        </div>
      </div>

      <Box sx={{ height: "auto", backgroundColor: "#2121210D" }}>
        <Box
          sx={{
            "& > :not(style)": {
              display: "flex",
              justifyContent: "space-around",
              height: "auto",
              width: "100%",
            },
          }}
        >
          <div>
            <Collapse in={showFilter} sx={{ width: "100%" }}>
              <div className="history-filters">
                <div className="row1">
                  <div className="child">
                    <FormControl
                      sx={{ margin: 0 }}
                      variant="standard"
                      fullWidth
                    >
                      <InputLabel htmlFor="standard-adornment-password">
                        {i18n(lang)?.history_filter_keyword}
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type={"text"}
                        placeholder={i18n(lang)?.search_word}
                        value={keywordValue}
                        onChange={(e) => {
                          setKeywordValue(e.target.value);
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <svg
                              width="25"
                              height="24"
                              viewBox="0 0 25 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_3158_5366"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="25"
                                height="24"
                              >
                                <rect
                                  x="0.75"
                                  width="24"
                                  height="24"
                                  fill="#D9D9D9"
                                />
                              </mask>
                              <g mask="url(#mask0_3158_5366)">
                                <path
                                  d="M19.65 20.3L14.05 14.7C13.55 15.1 12.975 15.4167 12.325 15.65C11.675 15.8833 10.9833 16 10.25 16C8.43333 16 6.896 15.371 5.638 14.113C4.37933 12.8543 3.75 11.3167 3.75 9.5C3.75 7.68333 4.37933 6.14567 5.638 4.887C6.896 3.629 8.43333 3 10.25 3C12.0667 3 13.6043 3.629 14.863 4.887C16.121 6.14567 16.75 7.68333 16.75 9.5C16.75 10.2333 16.6333 10.925 16.4 11.575C16.1667 12.225 15.85 12.8 15.45 13.3L21.075 18.925C21.2583 19.1083 21.35 19.3333 21.35 19.6C21.35 19.8667 21.25 20.1 21.05 20.3C20.8667 20.4833 20.6333 20.575 20.35 20.575C20.0667 20.575 19.8333 20.4833 19.65 20.3ZM10.25 14C11.5 14 12.5627 13.5627 13.438 12.688C14.3127 11.8127 14.75 10.75 14.75 9.5C14.75 8.25 14.3127 7.18733 13.438 6.312C12.5627 5.43733 11.5 5 10.25 5C9 5 7.93733 5.43733 7.062 6.312C6.18733 7.18733 5.75 8.25 5.75 9.5C5.75 10.75 6.18733 11.8127 7.062 12.688C7.93733 13.5627 9 14 10.25 14Z"
                                  fill="black"
                                  fillOpacity="0.5"
                                />
                              </g>
                            </svg>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                 

                  <div className="child">
                    <FormControl
                      variant="standard"
                      sx={{ margin: 0 }}
                      fullWidth
                    >
                      <InputLabel id={"filter_type"}>
                        {i18n(lang)?.history_filter_type}
                      </InputLabel>
                      <Select
                        labelId={"filter_type"}
                        id={"filter_type"}
                        label={i18n(lang)?.history_filter_type}
                        value={typeValue}
                        onChange={handleTypeChange}
                      >
                        <MenuItem value="alle">
                          <em>alle</em>
                        </MenuItem>
                        {[
                          {
                            name: "Störung",
                            value: 0,
                          },
                          {
                            name: "Auffälligkeit",
                            value: 1,
                          },
                          {
                            name: "Notiz",
                            value: 2,
                          },
                          {
                            name: "Aufgabe",
                            value: 3,
                          },
                          {
                            name: "Interne Mitteilung",
                            value: 4,
                          },
                          {
                            name: "Herstellermitteilung",
                            value: 5,
                          },
                          {
                            name: "Geplante Wartung",
                            value: 6,
                          },
                          {
                            name: "Wartung",
                            value: 7,
                          },
                        ].map((noti, key) => {
                          return (
                            <MenuItem value={noti.value} key={key}>
                              {noti.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="child">
                    <FormControl
                      variant="standard"
                      sx={{ margin: 0 }}
                      fullWidth
                    >
                      <InputLabel id={"filter_status"}>
                        {i18n(lang)?.history_filter_status}
                      </InputLabel>
                      <Select
                        labelId={"filter_status"}
                        id={"filter_status"}
                        label={i18n(lang)?.history_filter_status}
                        value={statusValue}
                        onChange={handleStatusChange}
                      >
                        <MenuItem value="alle">
                          <em>alle</em>
                        </MenuItem>
                        {[
                          {
                            name: "Offen",
                            value: 0,
                          },
                          {
                            name: "In Bearbeitung",
                            value: 1,
                          },
                          {
                            name: "Erledigt",
                            value: 2,
                          },
                        ].map((st, key) => {
                          return (
                            <MenuItem value={st.value} key={key}>
                              {st.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <div className="row3 HT">
                  <div
                    className="filter_export"
                    style={{
                      border: "1px solid #0000001F",
                      borderRadius: "4px",
                      padding: "9px 8px",
                    }}
                    onClick={handleExportClick}
                  >
                    <DownloadSvg />
                    {i18n(lang)?.export_pdf}
                  </div>
                  <div
                    className="filter_export"
                    style={{
                      borderRadius: "4px",
                      padding: "9px 8px",
                    }}
                  >
                    {i18n(lang)?.history_filter_reset}
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </Box>
      </Box>

      <div className="historyWrapper">
        <Grid item xs={7} style={{ margin: "0px auto" }}>
          <section className={"timelineWrapper"}>
            <Typography variant="h2" className={"sectionHeading"}>
              {getCurrentYear()}
            </Typography>

            <div className={"historyHeaderFirstItem"}>
              <IconText
                style={{ marginTop: "18px", marginBottom: "10px" }}
                icon={<TodaySvg />}
                text={i18n(lang)?.today + ": " + moment().format("DD.MM.YYYY")}
              />
            </div>

            <div className={"itemcardList"}>
              {_.orderBy(
                notifications,
                ["notification.created"],
                ["desc"]
              )?.map((item: any, index: any) => {
                return (
                  <>
                    {getYearFromTS(item?.notification?.created) ===
                    +getCurrentYear() ? (
                      <Grid item md={12} key={index}>
                        <NotificationCardItem
                          text={item.notification.title}
                          btColor={GetNotificationBorderColor(
                            item.notification.type
                          )}
                          statusColor={"red"}
                          type={item.notification.type}
                          status={item.notification.status}
                          notification={item.notification}
                          showHighlightedText
                          searchKeyword={keywordValue}
                          equipmentNodeId={machineData?.equipment?.nodeid}
                        />
                      </Grid>
                    ) : (
                      <div>
                        {"" + getYearFromTS(item?.notification?.created) !=
                        adjust_year ? (
                          ((adjust_year =
                            "" + getYearFromTS(item?.notification?.created)),
                          (
                            <>
                              <Typography
                                variant="h2"
                                className={"sectionHeading"}
                              >
                                {getYearFromTS(item?.notification?.created)}
                              </Typography>
                              
                              <NotificationCardItem
                                text={item.notification.title}
                                btColor={GetNotificationBorderColor(
                                  item.notification.type
                                )}
                                statusColor={"red"}
                                type={item.notification.type}
                                status={item.notification.status}
                                notification={item.notification}
                                showHighlightedText
                                searchKeyword={keywordValue}
                                equipmentNodeId={machineData?.equipment?.nodeid}
                              />
                             
                            </>
                          ))
                        ) : (
                          
                          <>
                            <NotificationCardItem
                              text={item.notification.title}
                              btColor={GetNotificationBorderColor(
                                item.notification.type
                              )}
                              statusColor={"red"}
                              type={item.notification.type}
                              status={item.notification.status}
                              notification={item.notification}
                              showHighlightedText
                              searchKeyword={keywordValue}
                              equipmentNodeId={machineData?.equipment?.nodeid}
                            />
                          </>
                        
                        )}
                      </div>
                    )}
                  </>
                );
              })}
            </div>

            <div className={"historyFooterLastItem"}>
              <IconText
                style={{ marginTop: "-7px", marginBottom: "14px" }}
                icon={<TodaySvg />}
                text={` ${i18n(lang)?.built_year} :  ${
                  machineData?.equipment?.constructiondate.length === 4
                    ? machineData?.equipment?.constructiondate
                    : moment(machineData?.equipment?.constructiondate).format(
                        "Y"
                      )
                }`}
              />
            </div>

            <div className={"timelineLineContainer"}>
              <span className={clsx("timelineBubble", "timelineBubbleStart")} />
              <hr className={"timelineLine"} />
              <span className={clsx("timelineBubble", "timelineBubbleEnd")} />
            </div>
          </section>
        </Grid>
      </div>
    </>
  );
}

export default History;
